module.exports = __webpack_public_path__ + "static/img/center-door-wall_256.eae54c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center-door-wall_256.png
// module id = 5+LF
// module chunks = 0